module.exports = __webpack_public_path__ + "img/dados-estorno.40b31403.png";